export default __webpack_public_path__ + "static/media/hsat-abs.08239f51.svg";